/* eslint-disable */
import namespace from './namespace';

export type ApiConfig = {
    baseUrl: string;
    authCookieAccess: string;
    eventsUrl: string;
    previewCookieName: string;
    cloudinaryCloudName: string;
    cloudinaryUploadPreset: string;
    snowplowDevelopmentEndpoint: string;
    snowplowProductionEndpoint: string;
    snowplowSourceEndpoint: string;
    environment: string;
};

const env = !namespace ? 'production' : 'development';

const config: ApiConfig = require(`./${env}`).default;
export default config;
